import React from 'react';
import { Redirect } from 'react-router-dom';

const CtiAuthentication = () => {
    return <Redirect to={'/signin'} />;
};

export default React.memo(CtiAuthentication);
